import React, { useState, useRef, useEffect } from 'react';
import * as Icons from '../../assets/svg/icons';

export const FlexiProofUpload = ({
    rxData,
    index,
    proofImage,
    setProofImage,
    rxnumber
}) => {
    const fileInputRef = useRef(null);
    const [preview, setPreview] = useState(null);

    // Update preview when proofImage changes externally
    useEffect(() => {
        // Handle both File object and {id, file} object structure
        let fileToPreview = null;
        if (proofImage instanceof File) {
            fileToPreview = proofImage;
        } else if (proofImage && proofImage.file) {
            fileToPreview = proofImage.file;
        } else if (proofImage && typeof proofImage === 'string') {
            setPreview(proofImage);
            return;
        }

        if (fileToPreview) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result);
            };
            reader.readAsDataURL(fileToPreview);
        } else {
            setPreview(null);
        }
    }, [proofImage]);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Validate file type
            if (!file.type.startsWith('image/')) {
                alert('Please upload an image file');
                e.target.value = '';
                return;
            }

            // Validate file size (max 10MB)
            if (file.size > 10 * 1024 * 1024) {
                alert('Image size should be less than 10MB');
                e.target.value = '';
                return;
            }

            setProofImage(file);
        }
    };

    const handleRemoveImage = () => {
        setProofImage(null);
        setPreview(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    const handleUploadClick = () => {
        fileInputRef.current?.click();
    };

    return (
        <div className="mt-2  bg-gray-50">

            {!preview && !proofImage ? (
                <div className="flex flex-col items-center justify-center border-2 border-dashed border-gray-300 rounded-md p-4 cursor-pointer hover:border-blue-400 transition-colors"
                    onClick={handleUploadClick}>
                    <div className="mb-2">
                        <Icons.CameraIcon />
                    </div>
                    <p className="text-xs text-gray-600 text-center">
                        Click to upload proof image
                    </p>
                    <p className="text-xs text-gray-400 mt-1">
                        (JPEG, PNG - Max 10MB)
                    </p>
                    {/* <input
                        ref={fileInputRef}
                        type="file"
                        accept="image/jpeg,image/jpg,image/png"
                        onChange={handleFileChange}
                        className="hidden"
                        id={`flexi-proof-upload-${index}-${rxnumber}`}
                    /> */}


                    <input
                        ref={fileInputRef}
                        type="file"
                        accept="image/*"
                        capture="environment"
                        onChange={handleFileChange}
                        className="hidden"
                        id={`flexi-proof-upload-${index}-${rxnumber}`}
                    />

                </div>
            ) : (
                <div className="relative">
                    <div className="border border-gray-300 rounded-md p-2 bg-white">
                        <img
                            src={preview || (proofImage instanceof File ? URL.createObjectURL(proofImage) : (proofImage?.file ? URL.createObjectURL(proofImage.file) : proofImage))}
                            alt={`Proof for ${rxnumber}`}
                            className="w-full h-auto max-h-48 object-contain rounded-md"
                        />
                    </div>
                    <button
                        onClick={handleRemoveImage}
                        className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 transition-colors"
                        style={{ width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
            )}
        </div>
    );
};

